module.exports = __webpack_public_path__ + "img/xingzhilun.b3094b16.png";